$(document).ready(function () {
	$(document).on('shown.bs.tab', ".vg-accessory-nav a", function () {
		let targetId = $(this).attr('href');
		let $target = $(targetId).find('.swiper-container');
		$target.data('init', true);
		VegasCarousel.init($target);
	});
});